/* eslint-disable no-redeclare */

export const RECLAIM_ACCOUNT = 'RECLAIM_ACCOUNT';
export const CLAIM_FORM = 'CLAIM_FORM';
export const MANUAL_ENTRY_FORM = 'MANUAL_ENTRY_FORM';
export const CLAIMED_COMPLETED = 'CLAIMED_COMPLETED';
export const EMAIL_MISMATCH = 'EMAIL_MISMATCH';
export const BOOKING_NOT_FOUND = 'BOOKING_NOT_FOUND';
export const DETAILS_MANUAL_ENTRY_FORM = 'DETAILS_MANUAL_ENTRY_FORM';
export const SELF_SERVE_ARRAY = 'SELF_SERVE_ARRAY';
export const CLAIMED = 'CLAIMED';
export const IMPORT_IN_PROGRESS = 'IMPORT_IN_PROGRESS';
export const IMPORT_ERROR = 'IMPORT_ERROR';
export const UPDATE_DOB = 'UPDATE_DOB';
export const READY_TO_CLAIM = 'READY_TO_CLAIM';
export const OTP_METHOD_SELECT = 'OTP_METHOD_SELECT';
export const OTP_SENT = 'OTP_SENT';
export const OTP_LOCKED = 'OTP_LOCKED';
export const NO_CONTACT_INFO = 'NO_CONTACT_INFO';

export const CLAIM_BOOKING_STEPS = {
  RECLAIM_ACCOUNT,
  CLAIM_FORM,
  UPDATE_DOB,
  EMAIL_MISMATCH,
  BOOKING_NOT_FOUND,
  DETAILS_MANUAL_ENTRY_FORM,
  SELF_SERVE_ARRAY,
  CLAIMED,
  READY_TO_CLAIM,
  CLAIMED_COMPLETED,
  NO_CONTACT_INFO,
} as const;

export const CLAIM_BOOKING_OTP_ONLY_STEPS = {
  OTP_METHOD_SELECT: 'OTP_METHOD_SELECT',
  OTP_SENT: 'OTP_SENT',
  OTP_VERIFICATION_LOCKED: 'OTP_VERIFICATION_LOCKED',
  EMAIL_SELECT_OTP: 'EMAIL_SELECT_OTP',
  CACHE_EXPIRED: 'CACHE_EXPIRED',
} as const;

export const CLAIM_BOOKING_ALL_STEPS = {
  ...CLAIM_BOOKING_STEPS,
  ...CLAIM_BOOKING_OTP_ONLY_STEPS,
} as const;

export type CLAIM_BOOKING_STEPS = (typeof CLAIM_BOOKING_ALL_STEPS)[keyof typeof CLAIM_BOOKING_ALL_STEPS];
export type CLAIM_BOOKING_STEPS_WITHOUT_OTP = (typeof CLAIM_BOOKING_STEPS)[keyof typeof CLAIM_BOOKING_STEPS];
export type CLAIM_BOOKING_OTP_ONLY_STEPS =
  (typeof CLAIM_BOOKING_OTP_ONLY_STEPS)[keyof typeof CLAIM_BOOKING_OTP_ONLY_STEPS];
